module.exports = __webpack_public_path__ + "img/6.73d064c5.jpeg";